import PropTypes from 'prop-types';
import { useRevalidator } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import RecommendConceptsClient from '../../clientAPI/recommendConcepts';
import { QUERY_KEYS } from '../../constants';
import ConceptView from './ConceptView';

export default function RecommendConceptsSearchByIdView({
  conceptId,
}: {
  conceptId: string;
}) {
  const revalidator = useRevalidator();
  const { data, error, status } = useQuery({
    queryKey: [QUERY_KEYS.RECOMMEND_CONCEPT_BY_ID, conceptId],
    queryFn: async () => {
      return RecommendConceptsClient.getConceptById(conceptId);
    },
    staleTime: Infinity,
    suspense: true,
    onError: (err: { status: number }) =>
      err.status === 401 && revalidator.revalidate(),
  });
  return (
    <div>
      {data && <ConceptView id={conceptId} loadChildren={false} data={data} />}
    </div>
  );
}

RecommendConceptsSearchByIdView.propTypes = {
  conceptId: PropTypes.string,
};
